export default {
  title: 'Liefersoft',
  form: {
    company_id: 'ID da empresa',
    login: 'Login',
    password: 'Palavra-passe',
  },
  buttons: {
    save: 'Guardar',
    edit: 'Editar',
    cancel: 'Cancelar',
  },
  toasts: {
    error: 'Falha ao guardar as alterações',
    success: 'Alterações guardadas',
  },
  instructions: {
    title: 'Instruções de configuração:',
    steps: {
      1: 'Vá a «Definições» > «Definições do Programa» > «API/Interfaces».',
      2: 'Adicione uma plataforma:\n• Clique no botão «Plataformas».\n• Introduza um nome de utilizador (p. ex., o nome da plataforma).\n• Clique em «Guardar».',
      3: 'Copie os dados da API:\n• Após guardar, aparecerá uma janela com o código da plataforma da API.\n• Copie os dados apresentados.',
    },
  },
  connected: {
    title: 'Liefersoft está ligado',
    description: 'Esta integração está configurada.',
  },
};
